"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.Input = void 0;
var styled_components_1 = __importStar(require("styled-components"));
exports.default = styled_components_1.default.div.attrs({
  className: 'TextArea'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", ";\n  background: ", ";\n  margin-bottom: 0.5rem;\n  & + .Text {\n    margin-bottom: 3.25rem;\n  }\n"])), function (props) {
  return props.width;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.farmProject.gray_2;
});
exports.Input = styled_components_1.default.textarea(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 80px;\n  background: ", ";\n  margin: 0.9em 0 -0.5rem;\n  width: 100%;\n  color: ", ";\n  font-size: 0.875rem;\n  font-family: ", ";\n  padding: 0.8em 1.1em;\n  box-sizing: border-box;\n  border-bottom: ", ";\n\n  &:focus {\n    outline: none;\n  }\n\n  &:active ~ label,\n  &:focus ~ label,\n  &:not(:empty) ~ label {\n    top: 0.5rem;\n    font-size: 0.6rem;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.farmProject.gray_2;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.farmProject.dark_gray;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.farmProject.font_family;
}, function (_ref5) {
  var theme = _ref5.theme,
    hasError = _ref5.hasError;
  return hasError ? "2px solid ".concat(theme.farmProject.error) : "1px solid ".concat(theme.farmProject.dark_gray);
});
exports.Label = styled_components_1.default.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background: ", ";\n  position: absolute;\n  padding-left: 0.8rem;\n  top: 1.4rem;\n  left: 0;\n  right: 0;\n  color: ", ";\n  font-size: 0.75rem;\n  pointer-events: none;\n  transition: 300ms ease all;\n  text-transform: initial;\n  text-align: left;\n  font-weight: 400;\n\n  ", "\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.farmProject.gray_2;
}, function (_ref7) {
  var theme = _ref7.theme,
    hasError = _ref7.hasError;
  return hasError ? theme.farmProject.error : theme.farmProject.dark_gray;
}, function (props) {
  return props.required && (0, styled_components_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      &::after {\n        content: '*';\n        color: ", ";\n      }\n    "])), function (_ref8) {
    var theme = _ref8.theme;
    return theme.farmProject.error;
  });
});